// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2024-04-30T08:47:47+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  180175
//    Project:        500
//    Environment:    3504 - master
//    MD5:            7d57be6559efefc6cc6e93dd10192b35
//    Signature:      eyJpdiI6InVoNXpkbSt6a1J0VzVNcjNTWG0zRXc9PSIsInZhbHVlIjoiN2JXZGdtdnRMY1JZQVNxa3VFa2JETnJweW5jaHBVcnk1TGNLV1wvS0UzK0pQeDZiZzQxRExodEI1UmVUMncrUXFwTCs1RTZyTkNzeEo2OFVYU0ZvN1BSZ05oVWVpVHB1TnV5SGlHeDhmWGVOeml6Ums5SEYzb0l3N2psV2M1Q3QyY2tGRFV4VXFWZnZLTFlZM3N0SkNBSkJuRnI0WXQ0em9IRVdVQmVkRU5RNnV1Z09PZExYY2NqSmFBMUFaV2gxdzFYcit1eCtETEZIbFNVeUluMnJwOFlWcG5KcERuMG9QeTZyeDBPcFpJQ3RqXC9sTDJhNGlZRnQ2dDhWK3d0MFNtNUVoRjhCZWIzQ2lrMVdGdUw4SjZTT3lYMTg4OUhXWFwvY3ZzV21xb2xJdm96ejJrRWV1alpQQmxoZWU5OGZPcFVIRlRIMjdTOXJaSlFCWHhtNnNlSk42cDNaN2pIMkZaWlZ2OXBcL2UxQzIrWWNXcVlVcW4xSGJaVFwvV2RhdUJiS0JMb1hQNVc4UzRCQWpsMm94V0VHSnZOM2ZKZ1hHNlJ2K1VnSE5CclFNWTBvPSIsIm1hYyI6IjYzNjE4NmMxYTgxMzZjMjgwZjlkNzc4OTdmZDVjMDZmMTViZmRhM2IwZjhmOWJhZWFjZjdkY2I4ZWI4OTVkNjIifQ==
// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2023-02-01T12:11:00+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  166479
//    Project:        500
//    Environment:    3504 - master
//    MD5:            a5ed4631870290e585bd9605247fe178
//    Signature:      eyJpdiI6IkVNUWpFR1grZkt2VjlHOXpQb0VWUnc9PSIsInZhbHVlIjoiZGZcL2RqeGlmTmhFTngrMHRURjg5NTFad2xJNTBMVFhvV29ZUVNLZnBRRVpLWkJkMG83bXdTdFdWejhjK2RPd01CNVB0Q0lUdkZWUWJtNTVETXAxRk5lK0NTSElZSmlcL2xhZzIwZlJoRHlqMUVEN2RFRWJXU2tiMVcrcUowa0VNU2dOWTdwdExCT0tUQWIzNklVdVprYnM0VWkyR3pIbGQxb0ZKU1wvcnpjMW1YWmV0WktBcEQxbkZQREF0ajJNa1p2VnRYVUNnZFhyZUV3NzJqclVGY3FcLzQ4ZHp3NndLMWFJRjZtd00yXC9FclpsSjNMaVJQalo5VmgxZWN5cVhJaEJ2VllCSkJKV0Z3dlUycXRIVkh0TWNROGpBRml3TEdBazgyQjNwNlo4T0s5ZDl6cGxzTXU1eVFCM3BobU1aUG5EeFp4WGNOaHVRSVkycnZCbTVHT2o4THpUVnJqNXU0UERkYUlVZmtFTHBwZjlHTEc0U2xOQVhycjYwTVd4UmdDdnY3QkM5U2szRllvVVlIcVR3dTgwd1RRN0pURE16RTlQdDhjVGdQQWRIQkw0PSIsIm1hYyI6ImQ4YjYwMTI1ZGJhZDllMDI2ZGY0MDhhNWYzZDViNzc4MDZjMmI5NGYxZDYyM2NkNTk2NWFhNDZhODI1NGM0OWYifQ==
// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionStyle: 'style2',
    //suggestionStyle2MainContainerSelector: '#shopify-section-header',
    suggestionMobileStyle: 'style2',
  }
};

//Set theme search mode to product only
window.theme.searchMode = 'product';

(function () {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };

  SearchInput.prototype.beforeBindEvents = function (id) {
    var id = this.id;
    if (id == Class.searchBox + '-0') {
      this.$element = removeThemeSearchEvent();
      this.instantSearchResult.$searchInputElement = this.$element;
    }
    recallThemeOnPageShowEvent();

    if (Utils.InstantSearch.isFullWidthMobile()) {
      jQ(id).removeAttr('autofocus');
      if (jQ(id).is(':focus')) {
        jQ(id).blur();
      }
    }
  };

  SearchInput.prototype.afterBindEvents = function() {
    // Fix cannot redirect to search page when pressing enter
    if(jQ('.boost-pfs-search-box').length > 0) {
      jQ('.boost-pfs-search-box').wrap('<form action="/search" method="get" role="search"></form>');
    }
  }

  function removeThemeSearchEvent() {
    // Remove all events
    if (jQ('[name="q"]').length > 0) {
      var cloneSearchBar = jQ('[name="q"]').first().clone();
      jQ(cloneSearchBar).removeClass('Form__Input').addClass('Search__Input Heading');
      jQ('[name="q"]').first().empty().append(cloneSearchBar);
      if (jQ('#Search').length > 0) {
        if (jQ('#Search').hasClass('Modal--fullScreen')) {
          jQ('#Search').attr("style", "height: 0px !important");
        }
        jQ('#Search .Search__Results').attr("style", "display: none !important");
      }

      // Rebuild click search icon event
      if (jQ('[data-action="toggle-search"]').length > 0) {
        jQ('[data-action="toggle-search"]').on('click', function () {
          setTimeout(function () {
            jQ('[name="q"]').first().focus();
          }, 500);
        })
      }
    }
    // disable page transition
    if (window.theme && window.theme.showPageTransition) {
      window.theme.showPageTransition = false;
    }
    return jQ('[name="q"]').first();
  }

  function recallThemeOnPageShowEvent() {
    // disable page transition
    var pageTransition = document.querySelector('.PageTransition');
    if (pageTransition) {
      pageTransition.style.visibility = 'visible';
      pageTransition.style.opacity = '0';
    }
    // refresh cart
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }
})();
